import { DataGridPremium } from "@mui/x-data-grid-premium";
import { useEffect, useState } from "react";
import Preloader from "../Preloader";
import { dataGridLang } from '../MemToolBar';
import Translate from "../../utils/Translate";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../utils/Api";
import { avatarColumn, textColumn, dateColumn, formattedColumn, numberColumn, StatisticsGridToolBar } from "./StatisticsCommon";
import { translateDayName } from "../../utils/dateTimeFormat";
import { CustomNoRowsOverlay } from '../../utils/StyledGridOverlay';
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import NumbersIcon from "@mui/icons-material/Numbers";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import PlaceIcon from "@mui/icons-material/Place";
import GroupIcon from "@mui/icons-material/Group";
import SchoolIcon from "@mui/icons-material/School";
import BusinessIcon from "@mui/icons-material/Business";
import MoneyIcon from "@mui/icons-material/Money";
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DeleteIcon from '@mui/icons-material/Delete';
import { formatDateWithMonthOffSet } from '../../utils/dateTimeFormat';
import Grid from '@mui/material/Grid';
import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useSnackbar } from 'notistack';
import { useMediaQuery } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import MyCourseBookingFilters from "./MyFilters/MyCourseBookingFilters";

const CourseBookingsStatistics = () => {

    const colNames = {
        dataId: 'dataId',
        partNo: 'partNo',
        partDesc: 'partDesc',
        licenseDesc: 'licenseDesc',
        courseId: 'courseId',
        shortComment: 'shortComment',
        courseIsInvoiced: 'courseIsInvoiced',
        courseCity: 'courseCity',
        teacher: 'teacher',
        teacherActorId: 'teacherActorId',
        responible: 'responible',
        company: 'company',
        externalId: 'externalId',
        actorId: 'actorId',
        region: 'region',
        fromDate: 'fromDate',
        toDate: 'toDate',
        price: 'price',
        noBookings: 'noBookings',
        noPartcipants: 'noPartcipants',
        noDays: 'noDays',
        noCourses: 'noCourses',
        year: 'year',
        quarter: 'quarter',
        month: 'month',
        weekNo: 'weekNo',
        weedDay: 'weedDay',
        iconName: 'iconName',
        courseIconUrl: 'courseIconUrl'
    };

    const columns = [
        // textColumn(colNames.dataId, null, 'DataId'),
        // textColumn(colNames.partNo, null, 'PartNo'),

        avatarColumn(colNames.licenseDesc, null, colNames.courseIconUrl, <SchoolIcon />, 'CourseType', 'rounded'),
        textColumn(colNames.partDesc, null, 'CourseNameLong'),
        // textColumn(colNames.courseId, null, 'CourseId'),
        textColumn(colNames.shortComment, null, 'ShortComment'),
        // booleanColumn(colNames.courseIsInvoiced, null, 'CourseIsInvoiced'), // alltid false
        textColumn(colNames.courseCity, <PlaceIcon />, 'CourseCity'),
        textColumn(colNames.teacher, <CoPresentIcon />, 'Instructor'),
        textColumn(colNames.teacherActorId, <CoPresentIcon />, 'TeacherActorId'),

        // textColumn(colNames.responible, null, 'Responible'), // innehåller inga data
        textColumn(colNames.company, <BusinessIcon />, 'Company'),
        textColumn(colNames.externalId, <NumbersIcon />, 'ExternalActorNo'), // TranslationKey: fältet är egentligen inte ExternalActorNo, men den texten passar
        // textColumn(colNames.actorId, null, 'ActorId'),
        textColumn(colNames.region, null, 'Region'),
        dateColumn(colNames.fromDate, <CalendarTodayIcon />, 'FromDate'),
        dateColumn(colNames.toDate, <EventAvailableIcon />, 'ToDate'),
        numberColumn(colNames.price, <MoneyIcon />, 'Price'),
        numberColumn(colNames.noBookings, <NumbersIcon />, 'NoBookings'),
        numberColumn(colNames.noPartcipants, <GroupIcon />, 'Students'),
        numberColumn(colNames.noDays, null, 'Days'),
        // textColumn(colNames.noCourses, null, 'NoCourses'), // altid 1
        textColumn(colNames.year, null, 'Year'),
        numberColumn(colNames.quarter, null, 'Quarter'),
        numberColumn(colNames.month, null, 'Month'),
        numberColumn(colNames.weekNo, null, 'Week'),
        formattedColumn(colNames.weedDay, null, 'Day', value => translateDayName(value)),
        //textColumn(colNames.iconName, null, 'IconName'),
    ];

    const initialHiddenColumns = [
        colNames.partDesc,
        // colNames.licenseDesc,
        colNames.shortComment,
        //courseCity,
        //teacher,
        colNames.responible,
        //company,
        colNames.externalId,
        colNames.region,
        //fromDate,
        colNames.toDate,
        colNames.price,
        colNames.noBookings,
        //noPartcipants,
        colNames.noDays,
        colNames.noCourses,
        colNames.year,
        colNames.quarter,
        colNames.month,
        colNames.weekNo,
        colNames.weedDay,
        colNames.iconName,
        colNames.courseIconUrl,
        colNames.teacherActorId,
    ];

    const localizedTextsMap = dataGridLang();
    const initialGridState = {
        sorting: { sortModel: [{ field: colNames.fromDate, sort: 'desc' }] }, // TODO
        columns: {
            columnVisibilityModel: initialHiddenColumns.reduce((ac, a) => ({ ...ac, [a]: false }), {})
        }
    };

    let i = 0;
    const navigate = useNavigate();
    const [licenses, setLicenses] = useState();
    const smallScreen = useMediaQuery('(max-width:700px)');
    const [dataFetched, setDataFetched] = useState(false);
    const api = useApi();

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [stdFilters, setStdFilters] = useState(["SelectFilter", "MyCourseBookings", "MyInstructorsCourseBookings", "UpcomingBookings"]);
    const [selectedStdFilter, setSelectedStdFilter] = useState("SelectFilter");
    const [filt, setFilt] = useState({
        items: []
    });

    const [teacherActorIds, setTeacherActorIds] = useState([]);
    const [actorId, setActorId] = useState("");

    const [openMyFilters, setOpenMyFilters] = useState(false);

    useEffect(async () => {
        await loadData();
    }, [api]);

    async function loadData() {
        const [data, filterData] =
            await Promise.all([
                api.fetch(
                    `${process.env.REACT_APP_MAIN_URL}courses/bookings/report/`,
                    false,
                    "GET"
                ),
                api.fetch(
                    `${process.env.REACT_APP_MAIN_URL}actors/teachers/filter/actorids`,
                    false,
                    "GET"
                ),
            ]);

        if (data && filterData) {
            let d = data.isSuccessful === false ? [] : data;
            d.forEach((element, index) => {
                element.id = index
            });
            setLicenses(d);

            if (filterData.isSuccessful !== false) {
                setTeacherActorIds(filterData.teacherActorIds);
                if (filterData.teacherActorIds.length < 1) {
                    setStdFilters(stdFilters.filter((i) => (i !== "MyInstructorsCourseBookings")))
                }
                setActorId(filterData.actorId);
                if (!filterData.actorId) {
                    setStdFilters(stdFilters.filter((i) => (i !== "MyCourseBookings")))
                }
            }
        }
        setDataFetched(true);
    }

    const navigateToCourse = (courseId) => {
        navigate(`/dashboard/course/${courseId}`, { replace: false });
    };

    function handleStdFilterChange(event) {
        setSelectedStdFilter(event.target.value);
        setStdFilter(event.target.value);
    }

    function setStdFilter(filterName) {
        switch (filterName) {

            case "SelectFilter":
                setFilt({ items: [] });
                break;

            case "MyCourseBookings":
                setFilt({
                    ...filt,
                    items:
                        [{
                            id: 1,
                            field: "teacherActorId",
                            operator: "equals",
                            value: actorId.toString(),
                            filterName: "MyCourseBookings"
                        }]
                });
                break;

            case "MyInstructorsCourseBookings":
                if (teacherActorIds.length < 1) {
                    enqueueSnackbar(Translate.get('FiltersMissingOrEmpty'), {
                        variant: 'warning',
                        autoHideDuration: 3000,
                    });

                    setFilt({ items: [] });
                    break;
                }

                setFilt({
                    ...filt,
                    items:
                        [{
                            id: 2,
                            field: "teacherActorId",
                            operator: "isAnyOf",
                            value: teacherActorIds.map(String),
                            filterName: "MyInstructorsCourseBookings"
                        }]
                });
                break;

            case "UpcomingBookings":
                setFilt({
                    ...filt,
                    items:
                        [
                            {
                                id: 3,
                                field: "toDate",
                                operator: "onOrAfter",
                                value: formatDateWithMonthOffSet(new Date(), 0),
                                filterName: "UpcomingBookings"
                            },
                            {
                                id: 4,
                                field: "fromDate",
                                operator: "onOrAfter",
                                value: formatDateWithMonthOffSet(new Date(), 0),
                                filterName: "UpcomingBookings"
                            },
                        ],
                    logicOperator: "or",
                });
                break;

            default:
                return;
        }
    }

    function clearFilters() {
        setFilt({ items: [] });
        setSelectedStdFilter("SelectFilter");
    }

    function handleFilterModelChange(newFilterModel, x) {
        if (x.reason === "restoreState") {
            return;
        }

        if (x.reason === "changeLogicOperator") {
            setFilt({
                ...filt,
                logicOperator: newFilterModel.logicOperator
            });
            return;
        }

        const newFilt = { items: newFilterModel.items, logicOperator: newFilterModel.logicOperator };
        setFilt(newFilt);

        var stdFilterExistsInFilters = newFilt.items.findIndex(e => e.filterName === selectedStdFilter)
        if (stdFilterExistsInFilters === -1) {
            setSelectedStdFilter("SelectFilter");
        }
    }

    return <div style={{ height: "70vh", /* border:"1px solid blue" */ }}> {/* TODO: är 70vh bra? */}
        {!dataFetched && <Preloader invisible={true} />}
        {dataFetched &&
            <>
                <Grid container justifyContent="flex-start" sx={{ ml: 1 }}>

                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{Translate.get('CourseBookingsStatisticsInfo')}</div>}>
                        <IconButton>
                            <InfoIcon color="primary" />
                        </IconButton>
                    </Tooltip>

                    <FormControl sx={{ minWidth: "5em" }}>
                        <InputLabel id="std-filter">{Translate.get("StdFilter") ?? " "}</InputLabel>
                        <Select
                            sx={{ maxWidth: smallScreen ? "10em" : "100%" }}
                            labelId="std-filter"
                            id="std-filter"
                            name="MyCourseBookingsFilter"
                            value={selectedStdFilter}
                            label={Translate.get("StdFilter") ?? " "}
                            onChange={handleStdFilterChange}
                        >
                            {stdFilters.map((element) =>
                                <MenuItem key={element} value={element} name={element}>{Translate.get(element)}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <Button
                        onClick={() => clearFilters()}
                        variant="outlined"
                        disabled={filt.items?.length === 0}
                        startIcon={<DeleteIcon />}
                        sx={{ ml: "1em" }}
                        size="xlarge"

                    >
                        {Translate.get("Purge")}
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => setOpenMyFilters(true)}
                        startIcon={<StarIcon />}
                        style={{ marginLeft: "1em" }}
                    >
                        {Translate.get("MyFilters")}
                    </Button>
                    <MyCourseBookingFilters
                        open={openMyFilters}
                        onClose={() => setOpenMyFilters(false)}
                        data={licenses}
                        setFilter={setFilt}
                    />
                </Grid>

                <DataGridPremium
                    getRowId={row => row.id}
                    rows={licenses}
                    filterModel={filt}
                    onFilterModelChange={(newFilterModel, x) => handleFilterModelChange(newFilterModel, x)}
                    columns={columns}
                    disableColumnMenu={true}
                    onRowClick={(params) => navigateToCourse(params.row.courseId)}
                    pageSizeOptions={[10, 50, 100]}
                    pagination={true}
                    localeText={localizedTextsMap}
                    components={{
                        Toolbar: () => StatisticsGridToolBar("courseBookingStatistics", "CourseBookings"),
                        NoRowsOverlay: CustomNoRowsOverlay(Translate.get('EmptyHere'))
                    }}
                    density='comfortable'
                    disableDensitySelector={true}
                    initialState={initialGridState}
                    disableRowSelectionOnClick
                // onExcelExportStateChange={(newState) =>{ 
                //     setDataFetched(newState !== "pending");
                // }}
                />
            </>
        }
    </div>
};

export default CourseBookingsStatistics;